module.exports = __webpack_public_path__ + "img/54.2030cc4e.gif";